const moderationFor = attachment =>
  attachment?.imageModeration || attachment?.image_moderation || {};

export const malwareScanFor = attachment =>
  attachment?.malwareScan || attachment?.malware_scan || {};

export const isMalwareBlocked = attachment => {
  const scan = malwareScanFor(attachment);

  return Boolean(scan.status && scan.status !== 'clean');
};

export const isAdminDownloadEligible = attachment => {
  const scan = malwareScanFor(attachment);
  return (
    isMalwareBlocked(attachment) &&
    ['dangerous_file_type', 'malware'].includes(scan.category) &&
    ['blocked', 'infected', 'quarantined'].includes(scan.status)
  );
};

export const isAttachmentBlocked = attachment => {
  const moderation = moderationFor(attachment);

  return (
    moderation.status === 'pending' ||
    (moderation.blocked === true && moderation.approved !== true) ||
    isMalwareBlocked(attachment)
  );
};
